<template>
  <el-card class="box-card form-screen mb-50 user-form">
    <el-row>
      <el-col :span="24">
        <div class="card-header" v-if="user && user.id">
          <span class="font-weight-700">{{ $t('users.form.input_labels.id') }}</span>  <span>{{ user.id }}</span>
          <hr>
        </div>
        <el-form :rules="rules" :model="form" ref="form" id="form" method="post" :action="action">
          <el-form-item class="full-name">
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.name') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-row>
              <div class="el-col mr-20 w-190">
                <el-form-item prop="first_name" :error="getErrorForField('first_name', errors)">
                  <el-input name="first_name" v-model="form.first_name" :placeholder="$t('users.form.input_placeholder.first_name')" class="input-small" @blur="trim('first_name')"></el-input>
                </el-form-item>
              </div>
              <div class="el-col w-190">
                <el-form-item prop="last_name" :error="getErrorForField('last_name', errors)">
                  <el-input name="last_name" v-model="form.last_name" :placeholder="$t('users.form.input_placeholder.last_name')" class="input-small" @blur="trim('last_name')"></el-input>
                </el-form-item>
              </div>
            </el-row>
          </el-form-item>
          <el-form-item prop="nickname" :error="getErrorForField('nickname', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.nickname') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="nickname" v-model="form.nickname" :placeholder="$t('users.form.input_placeholder.nickname')" @blur="trim('nickname')"></el-input>
          </el-form-item>
          <el-form-item prop="avatar_image_url" :error="getErrorForField('avatar_image_url', errors)" class="file-input">
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.avatar') }}</label>
            <el-avatar :size="100" :src="imageUrl" v-if="imageUrl" class="mr-10"/>
            <label class="btn-upload">
              <input type="file" name="avatar" @change="onFileChange" id="avatar" accept="image/jpg, image/jpeg, image/png">ファイルを選択
            </label>
            <span class="file-name">{{ form.image_name }}</span>
            <div class="text-error-custom">{{ imageError }}</div>
          </el-form-item>
          <el-form-item :error="getErrorForField('birthday', errors)" class="w-400" prop="birthday">
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.birthday') }} <span class="text-required">{{ $t('required') }}</span></label>
            <date-form @change-date="setBirthday" :date="form.data_birthday" v-model="form.data_birthday"></date-form>
          </el-form-item>
          <el-form-item>
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.gender') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-radio-group v-model="form.gender">
              <el-radio :label="item.key" name="gender" v-for="item in listGender" :key="item.key">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="tel" :error="getErrorForField('tel', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.tel') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="tel" v-model="form.tel" :placeholder="$t('users.form.input_placeholder.tel')"  @blur="trim('tel')"></el-input>
          </el-form-item>
          <el-form-item prop="mail_address" :error="getErrorForField('mail_address', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.mail_address') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-input name="mail_address" v-model="form.mail_address" :placeholder="$t('staff.form.input_placeholder.mail_address')" @blur="trim('mail_address')"></el-input>
          </el-form-item>
          <div class="group-input"><span>{{ $t('users.users_info') }}</span></div>
          <el-form-item>
            <label slot="label" class="el-form-item__label">{{ $t('users.form.input_labels.status') }} <span class="text-required">{{ $t('required') }}</span></label>
            <el-radio-group v-model="form.status">
              <el-radio label="1" name="status">{{ $t('status.active') }}</el-radio>
              <el-radio label="0" name="status">{{ $t('status.inactive') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <input type="hidden" name="_token" :value="csrf">
          <input type="hidden" name="birthday" :value="form.birthday">
          <input type="hidden" name="avatar_image_url" :value="form.avatar_image_url">
          <input type="hidden" name="file_name" :value="form.image_name">
          <input type="hidden" name="id" :value="user.id" v-if="user && user.id">
          <el-form-item class="btn-container">
            <el-button type="primary" @click="submit('form')" class="btn btn-submit">{{ labelBtnSubmit }}</el-button>
            <el-button @click="back" class="btn btn-back">{{ $t('back') }}</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import {YEARS, MONTHS, GENDERS, IMAGE_EXTENSIONS, AGES} from '../../constants'
import {checkAge} from '../../common'
import { upload } from '../../api/upload'

export default {
  props: {
    prefectures: { type: Array, required: true, default: [] },
    errors: { type: Object, required: false },
    input: { type: Object, required: false },
    user: { type: Object, default: {} },
    urls: { type: Object, default: {} },
  },
  data() {
    const checkRegexTel = (rule, value, callback) => {
        const regex = new RegExp(/^([0-9\s\-]*)$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.tel_format')));
        } else {
          callback();
        }
    }

    const checkBirthdDay = (rule, value, callback) => {
        if (checkAge(value) < AGES) {
          callback(new Error('error'));
        } else {
          callback();
        }
    }

    return {
      form: {
        first_name: '',
        last_name: '',
        nickname: '',
        name: '',
        avatar_image_url: '',
        data_birthday: { year: '', month: '', day: '' },
        birthday: '',
        gender: 1,
        tel: '',
        mail_address: '',
        login_id: '',
        status: '1',
        message_text: '',
        image_name: this.$t('no_file_choose')
      },
      rules: {
        first_name: [
          { required: true, message: this.$t('errors.required', [this.$t('users.form.input_placeholder.first_name')]), trigger: 'blur' },
          { max: 255, message: this.$t('errors.max', [this.$t('users.form.input_placeholder.first_name'), 255]), trigger: 'blur' },
        ],
        last_name: [
          { required: true, message: this.$t('errors.required', [this.$t('users.form.input_placeholder.last_name')]), trigger: 'blur' },
          { max: 255, message: this.$t('errors.max', [this.$t('users.form.input_placeholder.last_name'), 255]), trigger: 'blur' },
        ],
        nickname: [
          { required: true, message: this.$t('errors.required', [this.$t('users.form.input_placeholder.nickname')]), trigger: 'blur' },
          { max: 10, message: this.$t('errors.max', [this.$t('users.form.input_placeholder.nickname'), 10]), trigger: 'blur' },
        ],
        mail_address: [
          { required: true, message: this.$t('errors.required', [this.$t('users.form.input_placeholder.mail_address')]), trigger: 'blur' },
          { max: 255, message: this.$t('errors.max', [this.$t('users.form.input_placeholder.mail_address'), 255]), trigger: 'blur' },
          { type: "email", message: this.$t('errors.mail'), trigger: 'blur' }
        ],
        tel: [
          { required: true, message: this.$t('errors.required', [this.$t('shops.form.input_labels.tel')]), trigger: 'blur' },
          { max: 15, message: this.$t('errors.max', [this.$t('shops.form.input_labels.tel'), 15]), trigger: 'blur' },
          { validator: checkRegexTel, trigger: 'blur' },
        ],
        birthday: [
          { required: true, message: this.$t('errors.required', [this.$t('users.form.input_labels.birthday')]), trigger: 'blur' },
          { validator: checkBirthdDay, age: 18, message: this.$t('errors.age', [this.$t('users.form.input_labels.birthday'), 18]), trigger: 'blur' },
        ],
      },
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      labelBtnSubmit: this.$t('create'),
      action: '/users/store',
      years: YEARS,
      months: MONTHS,
      shops: [],
      disableSelectShop: true,
      listGender: GENDERS,
      imageError: '',
      imageUrl: ''
    }
  },
  methods: {
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid && this.form.birthday) {
          const form = document.getElementById("form");
          const file = document.getElementById('avatar').files[0];
          if (file) {
            this.uploadFileAndSubmit(file, form);
          } else {
            document.querySelector(".el-container").classList.add("disabled");
            document.querySelector("#loader").style.display = "block";
            form.submit();
          }
        } else {
          this.$refs['form'].validateField('birthday')
          return false;
        }
      });
    },

    isErrorForField(field, errors) {
      return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
    },

    getErrorForField(field, errors) {
      return this.isErrorForField(field, errors) ? errors[field][0] : '';
    },

    back() {
      window.location.href = this.urls.back;
    },

    handleZipcode() {
      this.form.zip_code = this.form.zip_code.replace(/\D/g,'');
      if (this.form.zip_code.length > 7) {
        this.form.zip_code = this.form.zip_code.substr(0, 7);
      }
    },

    onFileChange(e) {
      const file = e.target.files[0];
      const extension = file.name.split('.').pop();
      this.form.image_name = file.name;

      if (!IMAGE_EXTENSIONS.includes(extension)) {
        this.imageError = this.$t('errors.image.type');
        this.imageUrl = '';
        return;
      }

      if (file.size > this.$maxSizeImageByte) {
        this.imageError = this.$t('errors.image.max', [this.$t('staff.form.input_labels.avatar'), this.$maxSizeImage]);
        this.imageUrl = '';
        return;
      }

      this.imageError = '';
      this.imageUrl = URL.createObjectURL(file);
    },

    uploadFileAndSubmit(file, form) {
      upload(file)
        .then(response => response.json())
        .then(response => {
          this.form.avatar_image_url = response.data.url;
          this.form.image_name = response.data.file_name;
          this.imageUrl = response.data.url;
        })
        .then(() => {
          form.submit();
        });
    },

    setBirthday(data) {
      this.form.data_birthday = data;
      if (data.year && data.month && data.day) {
        let day = this.$dayjs(new Date(data.year, data.month - 1, data.day)).format('YYYY/MM/DD');
        this.form.birthday = day;
        this.$refs['form'].clearValidate('birthday');
        if (checkAge(day) < AGES) {
          this.$refs['form'].validateField('birthday')
        }
      }
    },

    trim(field) {
      if (this.form[field]) {
        this.form[field] = this.form[field].trim();
      }
    }
  },
  created() {
    const tempData = (Object.keys(this.input).length === 0) ? this.user : this.input;
    this.form = Object.fromEntries(Object.entries(tempData).map(([key, value]) => [key, value]));
    this.form.status = (tempData.hasOwnProperty('status')) ? tempData.status.toString() : '1';
    this.form.gender = (tempData.hasOwnProperty('gender')) && tempData.gender ? tempData.gender.toString() : '1';
    this.imageUrl = (tempData.avatar_image_url) ? tempData.avatar_image_url : '';
    this.form.image_name = (tempData.file_name) ? tempData.file_name : this.$t('no_file_choose');

    if (tempData.birthday) {
      this.form.birthday = this.$dayjs(tempData.birthday).format('YYYY/MM/DD');
      this.form.data_birthday = {
        year: this.$dayjs(tempData.birthday).format('YYYY'),
        month: this.$dayjs(tempData.birthday).format('MM'),
        day: this.$dayjs(tempData.birthday).format('DD')
      }
    }

    if (Object.keys(this.user).length > 0) {
      this.labelBtnSubmit = this.$t('update');
      this.action = 'update';
    }
  },
}
</script>

<style lang="scss" scoped>
  .user-form .el-avatar {
    --el-avatar-bg-color: #E9E5DF;
  }
</style>
